import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ScenarioSectionProp } from ".";
import UTIL from "../../../../../utils/utils";


const RiskTypeSection = (props: ScenarioSectionProp) => {

    const { t } = useTranslation();
    const { data } = props;

    return (
        <div className="section-wrapper">
            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbType")}
                    >
                        <span>{UTIL.getRiskTypeName(data.risk_type)}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 24]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbDescriptionOfOverlap")}
                    >
                        <span>{data.description_of_overlap}</span>
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default RiskTypeSection;